export default __webpack_public_path__ + "static/media/4s.7393a0e3.png";